"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OtkIdentityService = void 0;
var rest_service_1 = require("./rest.service");
var auth_service_1 = require("./auth.service");
var enums_1 = require("../shared/enums");
var models_1 = require("../shared/models");
var OtkIdentityService = /** @class */ (function (_super) {
    __extends(OtkIdentityService, _super);
    function OtkIdentityService(configService) {
        var _this = this;
        var authServiceInstance = new auth_service_1.AuthService();
        _this = _super.call(this, {
            serviceName: enums_1.ServicesEnum.OTK_IDENTITY,
            baseURL: configService.config.otkIdentityServiceUrl,
            authService: authServiceInstance,
        }) || this;
        _this.launchesResource = 'launches';
        _this.redeemLaunchPath = 'redeem-launch/:launchId';
        _this.legacyRedeemLaunchPath = 'launches/:launchId';
        _this.sendEmailPath = 'users/password/email';
        _this.resetPasswordPath = 'users/password/token';
        _this.schoolUsersPath = 'schools/:schoolUUID/users';
        _this.shopifyLaunchesPath = 'shopify/launches/:shopifyid';
        _this.loginPath = 'login';
        _this.userByGuidPath = 'users';
        _this.authService = authServiceInstance;
        _this.lmsUrl = configService.config.lmsUrl;
        return _this;
    }
    OtkIdentityService.prototype.requestPasswordResetEmail = function (email, brand) {
        return __awaiter(this, void 0, void 0, function () {
            var rejectReason_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.request(this.sendEmailPath, enums_1.RequestMethodEnum.PUT, {
                                email: email,
                                brand: brand,
                            }, null, false, {
                                Accept: '*/*',
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        rejectReason_1 = _a.sent();
                        throw new Error('Unable to reach the service -> ' + rejectReason_1);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    OtkIdentityService.prototype.resetPasswordWithToken = function (password, token) {
        return __awaiter(this, void 0, void 0, function () {
            var rejectReason_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.request(this.resetPasswordPath, enums_1.RequestMethodEnum.PUT, {
                                token: token,
                                password: password,
                            }, null, false, {
                                Accept: '*/*',
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        rejectReason_2 = _a.sent();
                        throw new Error('Unable to reach the service -> ' + rejectReason_2);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    OtkIdentityService.prototype.login = function (username, password, brand) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var response, rejectReason_3;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.request(this.loginPath, enums_1.RequestMethodEnum.POST, {
                                username: username,
                                password: password,
                            }, { brand: (_a = (this.authService.brand || brand)) === null || _a === void 0 ? void 0 : _a.toUpperCase() }, false)];
                    case 1:
                        response = _b.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        rejectReason_3 = _b.sent();
                        throw new models_1.ApiError('Unable to login -> ' + rejectReason_3, rejectReason_3);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    OtkIdentityService.prototype.getUser = function (userGuid) {
        return __awaiter(this, void 0, void 0, function () {
            var response, rejectReason_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.serviceName = enums_1.ServicesEnum.IDENTITY;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.show(this.userByGuidPath, userGuid)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 3:
                        rejectReason_4 = _a.sent();
                        throw new Error('Unable to get user -> ' + rejectReason_4);
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    OtkIdentityService.prototype.getSchoolUsers = function (schoolUUID) {
        return __awaiter(this, void 0, void 0, function () {
            var schoolId, response, rejectReason_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        schoolId = schoolUUID || this.authService.schoolId || '';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.request(this.schoolUsersPath.replace(':schoolUUID', schoolId))];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 3:
                        rejectReason_5 = _a.sent();
                        throw new Error("Unable to get user from school '".concat(schoolId, "' -> ") + rejectReason_5);
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * createLaunchId
     * @description Creates a short-lived launchID that can be redeemed for a JWT token later
     */
    OtkIdentityService.prototype.createLaunchId = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, userId, schoolId, role, brand, response, rejectReason_6;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.authService, userId = _a.userId, schoolId = _a.schoolId, role = _a.role, brand = _a.brand;
                        if (!userId || !schoolId || !role || !brand) {
                            throw new Error('Unable create LaunchID due to invalid userId and/or schoolId in JWT token');
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.update(this.launchesResource, {
                                userId: userId,
                                schoolId: schoolId,
                                role: role,
                            }, undefined, undefined, { brand: brand })];
                    case 2:
                        response = _b.sent();
                        return [2 /*return*/, response.data];
                    case 3:
                        rejectReason_6 = _b.sent();
                        throw new Error('Error while creating a new launch id -> ' + rejectReason_6);
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * fetchLaunchLocationLMS
     * @description Fetch the launch url for the new lms
     */
    OtkIdentityService.prototype.fetchLMSLaunchLocation = function () {
        return __awaiter(this, void 0, void 0, function () {
            var launchData, rejectReason_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.createLaunchId()];
                    case 1:
                        launchData = _a.sent();
                        return [2 /*return*/, this.lmsUrl + '/' + this.redeemLaunchPath.replace(':launchId', launchData.id)];
                    case 2:
                        rejectReason_7 = _a.sent();
                        throw new Error('Unable to fetch LMS launch location -> ' + rejectReason_7);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * showLaunchID
     * @param id - the launch id
     * @description fetches the launch id
     */
    OtkIdentityService.prototype.showLaunchId = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var response, rejectReason_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.show(this.launchesResource, id).catch(function (error) {
                                var _a;
                                if (((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 302) {
                                    return error.response;
                                }
                                else {
                                    throw error;
                                }
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        rejectReason_8 = _a.sent();
                        throw new Error('Unable to show LaunchID -> ' + rejectReason_8);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * fetchLegacyLmsLaunchLocation
     * @description Fetch the launch url for the legacy lms
     */
    OtkIdentityService.prototype.fetchLegacyLmsLaunchLocation = function (legacyLmsUrl) {
        return __awaiter(this, void 0, void 0, function () {
            var launchData, rejectReason_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.createLaunchId()];
                    case 1:
                        launchData = _a.sent();
                        return [2 /*return*/, legacyLmsUrl + '/' + this.legacyRedeemLaunchPath.replace(':launchId', launchData.id)];
                    case 2:
                        rejectReason_9 = _a.sent();
                        throw new Error('Unable to fetch Legacy LMS launch location -> ' + rejectReason_9);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @param shopifyId ID For a Shopify Customer
     * @param path Path to redirect user to in Shopify
     */
    OtkIdentityService.prototype.getShopifyLaunchesUrl = function (shopifyId, path) {
        return __awaiter(this, void 0, void 0, function () {
            var response, rejectReason_10;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.request(this.shopifyLaunchesPath.replace(':shopifyid', shopifyId), enums_1.RequestMethodEnum.GET, null, { path: path })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        rejectReason_10 = _a.sent();
                        throw new Error('Unable to get Shopify SSO launch location -> ' + rejectReason_10);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return OtkIdentityService;
}(rest_service_1.RestService));
exports.OtkIdentityService = OtkIdentityService;
